import { OvlAddScreen } from "../../../../../../../_ovlclient/src/global/globals"
import { CompSettings } from "./settingsscreen"

export const GENSettings_Init = () => {
  OvlAddScreen(CompSettings, "GENSettings")
}
